import moment from 'moment'
import i18n from './i18n'
import store from '../store'
import data from '@/client/lib'

const helper = {
  visualizationTypeIcon (type) {
    let icon = ''

    if (type === 'scheme') {
      icon = 'fa-object-group'
    } else if (type === 'diagram') {
      icon = 'fa-line-chart'
    } else if (type === 'download') {
      icon = 'fa-download'
    } else if (type === 'image') {
      icon = 'fa-picture-o'
    } else if (type === 'account') {
      icon = 'fa-user'
    } else if (type === 'friend') {
      icon = 'fa-share-alt'
    } else if (type === 'extended-report') {
      icon = 'fa-file-text-o'
    } else if (type === 'report') {
      icon = 'fa-calendar'
    }
    return icon
  },

  isMobile (breakpoint) {
    /* eslint-disable no-unneeded-ternary */
    return (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
      navigator.userAgent.match(/Opera Mini/i) ||
      navigator.userAgent.match(/IEMobile/i) ||
      breakpoint.xs) ? true : false
  },

  unitText (unit, unitCode, displayUnit, unitText2) {
    let unitText = unit

    if (unitCode === 'Ohms') {
      unitText = '&#8486'
    }

    if (!unit || unitCode === 'None') {
      unitText = ''
    }

    if (displayUnit) {
      unitText = displayUnit
    }

    if (!displayUnit && unitText2) {
      unitText = unitText2
    }

    return unitText
  },

  ownTimerange (period, start, end) {
    let html = ''

    if (period === 7) {
      html = moment(start).format('DD.MM.YYYY').toString() + ' - ' + moment(end).format('DD.MM.YYYY').toString()
    }
    return html
  },

  formatDateTime (dateTime, type) {
    let format = ''
    if (!dateTime) {
      return ''
    } else if (!type) {
      format = store.state.settings.dateTimeFormat
    } else if (type === 'date') {
      format = store.state.settings.dateFormat
    } else if (type === 'time') {
      format = store.state.settings.timeFormat
    } else if (dateTime && type === 'dateAndDaysLeft') {
      format = store.state.settings.dateFormat
      let remainingDays = moment(dateTime).diff(moment(), 'days') + ' ' + i18n.t('general.days')
      if (parseInt(remainingDays) <= 0) {
        remainingDays = i18n.t('professional.expired')
      }
      return moment(dateTime).format(format) + ' (' + remainingDays + ')'
    } else if (!dateTime && type === 'dateAndDaysLeft') {
      return i18n.t('professional.expired')
    }
    return moment(dateTime).format(format)
  },

  notificationPeriod (period, notificationTime, weekday, day, month) {
    let str = ''

    let lng = i18n.i18next.language
    moment.locale(lng)

    if (notificationTime) {
      notificationTime = notificationTime.slice(0, -3)
    }

    if (period === 1) {
      str += i18n.t('general.daily') + ' ' + i18n.t('general.at') + ' ' + notificationTime + ' ' + i18n.t('general.oClock')
    } else if (period === 2) {
      str += i18n.t('general.weekly') + ' ' + i18n.t('general.on') + ' ' + moment().isoWeekday(parseInt(weekday)).format('dddd') + ' ' + i18n.t('general.at') + ' ' + notificationTime + ' ' + i18n.t('general.oClock')
    } else if (period === 3) {
      if (!day) {
        day = '1'
      }
      str += i18n.t('general.every') + ' ' + day + '. ' + i18n.t('reports.dotDayOfMonth') + ' ' + i18n.t('general.at') + ' ' + notificationTime + ' ' + i18n.t('general.oClock')
    } else if (period === 4) {
      str += i18n.t('general.endOfQuarter') + ' (' + moment.utc().endOf('quarter').add(1, 'days').format('DD.MM.YYYY') + ' ' + notificationTime + ')'
    } else {
      str += period + ' ' + i18n.t('general.error')
    }
    return str
  },

  getFormatName (format) {
    return i18n.t(data.downloadFormats[format])
  },

  lastQuarter () {
    const from = moment().startOf('quarter').subtract(1, 'quarter')
    const until = moment(from).endOf('quarter')
    return ' (' + from.format('MMMM') + ' - ' + until.format('MMMM') + ')'
  },

  getPeriodName (index) {
    const labels = data.periodLables

    if (!index) {
      return i18n.t(labels[0])
    } else if (index === 7) {
      return i18n.t('general.customRange')
    } else if (index === 10) {
      return i18n.t('general.lastQuarter') + helper.lastQuarter()
    }
    return i18n.t(labels[index])
  },

  convertSieveInterval (interval) {
    if (interval !== undefined) {
      const i = parseInt(interval) / 60
      let result = ''

      if (i === 1) {
        result = i + ' ' + i18n.t('general.minute')
      } else {
        result = i + ' ' + i18n.t('general.minutes')
      }
      return result
    } else {
      return interval
    }
  },

  newFirmwareVersion (version) {
    if (version) {
      let str = i18n.t('device.newFirmwareAvailable').replace('__VERSION__', version)
      return str
    } else {
      return '???'
    }
  },

  seperateDateTime (dateTime) {
    const result = {
      date: 'DD.MM.YYYY',
      time: 'HH:mm:ss'
    }
    if (!dateTime) {
      return result
    }
    const tmp = dateTime.split(' ')
    if (tmp.length === 2) {
      // DD.MM.YYYY HH:mm:ss
      // YYYY/DD/MM HH:mm:ss
      // DD/MM/YYYY HH:mm:ss
      // MM/DD/YYYY HH:mm:ss
      // YYYY-MM-DD HH:mm:ss
      result.date = dateTime.split(' ')[0]
      result.time = dateTime.split(' ')[1]
    } else if (tmp.length === 3) {
      // MM/DD/YYYY h:m:s AM/PM
      result.date = dateTime.split(' ')[0]
      result.time = dateTime.split(' ')[1] + ' ' + dateTime.split(' ')[2]
    } else if (tmp.length === 4) {
      // D MMMM YYYY HH:mm:ss
      result.date = dateTime.split(' ')[0] + ' ' + dateTime.split(' ')[1] + ' ' + dateTime.split(' ')[2]
      result.time = dateTime.split(' ')[3]
    }
    return result
  },

  install (Vue) {
    Vue.prototype.$escapeHtml = function (str) {
      if (str === undefined || typeof str !== 'string') {
        return null
      }
      const escaped = str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/(?:\r\n|\r|\n)/g, '<br />')
        .replace(/'/g, '&#39;')
      return escaped
    }

    Vue.prototype.$unescapeHtml = function (str) {
      if (str === undefined || typeof str !== 'string') {
        return null
      }

      const unescaped = str
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/<br\s*\/?>/mg, '\n')
        .replace(/&#39;/g, "'")
      return unescaped
    }

    Vue.prototype.$sortReceivers = function (a, b) {
      if (a.confirmed === b.confirmed) {
        return (a.receiver < b.receiver) ? -1 : (a.receiver > b.receiver) ? 1 : 0
      } else {
        return (a.confirmed < b.confirmed) ? -1 : 1
      }
    }

    Vue.prototype.$swapArrayElements = function (array, fromIndex, toIndex) {
      const [element] = array.splice(fromIndex, 1)
      array.splice(toIndex, 0, element)
      return array
    }

    Vue.prototype.$checkParamsId = function (id) {
      if (id) {
        const str = id.toString()
        const match = str.match(/^[1-9][0-9]*$/)
        if (match) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }

    Vue.prototype.$getDeviceImage = function (productId) {
      const KM2DL2Plus = [7, 8, 10, 14, 15, 22, 23, 24, 25]
      let img = null
      const path = 'static/images/'
      if (productId === 1 || productId === 4) {
        img = path + 'DL2_75x75.png'
      } else if (productId === 2 || productId === 3) {
        img = path + 'DL3_75x75.png'
      } else if (KM2DL2Plus.includes(productId)) {
        img = path + 'KM2_75x75.png'
      } else if (productId === 5) {
        img = path + 'KM1_75x75.png'
      } else if (productId === 11) {
        img = path + 'VBusModbus_75x75.png'
      } else if (productId === 12) {
        img = path + 'DeltaSol_MX_Plus_75x75.png'
      } else if (productId === 18) {
        img = path + 'Regler_PV_MAX_75x75.png'
      } else if (productId === 19 || productId === 20) {
        img = path + 'Tuxhorn_tubra-eTherm_S9_75x75.png'
      } else if (productId === 21) {
        img = path + 'SLR_XT2_75x75.png'
      } else if (productId === 16 || productId === 26) {
        img = path + 'KM-IP_75x75.png'
      } else {
        img = path + 'VBusNet.png'
      }
      return img
    }
    Vue.prototype.$helper = {
      isMobile: this.isMobile,
      visualizationTypeIcon: this.visualizationTypeIcon,
      unitText: this.unitText,
      ownTimerange: this.ownTimerange,
      formatDateTime: this.formatDateTime,
      notificationPeriod: this.notificationPeriod,
      getFormatName: this.getFormatName,
      getPeriodName: this.getPeriodName,
      convertSieveInterval: this.convertSieveInterval,
      newFirmwareVersion: this.newFirmwareVersion,
      seperateDateTime: this.seperateDateTime
    }
  }
}

export default helper



// WEBPACK FOOTER //
// ./src/plugins/helper.js